import { DateTime } from 'luxon'

import { CreateRoomFormErrorsType } from './codingRooms.types'
import { wordList } from './data'

export function formatTime(inputString: string) {
  const dateTime = DateTime.fromISO(inputString)
  const formattedTime = dateTime.toFormat('h:mm a')

  return formattedTime
}

const initialErrors: CreateRoomFormErrorsType = {
  roomName: null,
  topics: null,
  difficulties: null,
  roomStartTime: null
}

export const validateCreateRoomForm = ({
  roomName,
  topics,
  difficulties,
  roomStartTime,
  isScheduledRoom
}: {
  roomName: string
  topics: string[]
  difficulties: string[]
  roomStartTime: string
  isScheduledRoom: boolean
}): CreateRoomFormErrorsType => {
  const errors: CreateRoomFormErrorsType = { ...initialErrors }
  const selectedRoomStartTime = new Date(roomStartTime).getTime()
  const currentTime = new Date().getTime()

  if (roomName.trim().length === 0) {
    errors.roomName = 'Room name is required'
  }

  if (topics.length === 0) {
    errors.topics = 'At least one topic is required'
  }

  if (difficulties.length === 0) {
    errors.difficulties = 'At least one difficulty is required'
  }

  if (
    isScheduledRoom &&
    (!selectedRoomStartTime || selectedRoomStartTime < currentTime)
  ) {
    errors.roomStartTime = 'Start time must be in the future'
  }

  return errors
}

export const generateRoomName = () => {
  const firstWordIndex = Math.floor(Math.random() * wordList.length)
  const secondWordIndex = Math.floor(Math.random() * wordList.length)
  const firstWord = wordList[firstWordIndex]
  const secondWord = wordList[secondWordIndex]

  return `${firstWord}${secondWord}`
}

export const getRandomDifficulty = () => {
  const difficulties = ['easy', 'medium', 'hard'] as const
  const randomDifficulty = difficulties[Math.floor(Math.random() * 2)]

  return [randomDifficulty]
}

export const getRandomTopic = (): string[] => {
  const topics = ['arrays', 'strings', 'hashmap']
  const randomCount = Math.floor(Math.random() * topics.length) + 1

  // shuffle the copy using the Fisher-Yates algorithm
  for (let i = topics.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[topics[i], topics[j]] = [topics[j], topics[i]]
  }

  return topics.slice(0, randomCount)
}

export const getRandomQuestionCount = () => {
  return Math.floor(Math.random() * 5) + 1
}

export const getRandomRoomTime = () => {
  const randomNumber = Math.floor(Math.random() * 3)
  return randomNumber.toString()
}
